import { render } from "./VoiceCloning.vue?vue&type=template&id=7317fbae&scoped=true"
import script from "./VoiceCloning.vue?vue&type=script&lang=js"
export * from "./VoiceCloning.vue?vue&type=script&lang=js"

import "./VoiceCloning.vue?vue&type=style&index=0&id=7317fbae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7317fbae"]])

export default __exports__